import {createGlobalStyle} from "styled-components";
import {useContext} from 'react'
import {ThemeContext} from "../context";
import {colors} from "../colors";

const StyledGlobalStyle = createGlobalStyle<{ $isDarkMode: boolean }>`
  * {
    font-family: 'Trebuchet MS', Helvetica, sans-serif;
    box-sizing: border-box;
  }

  body {
    background-color: ${({$isDarkMode}) => ($isDarkMode ? colors.dark : colors.white)};
    margin: 0;
  }
`

export function GlobalStyle() {

    const {theme} = useContext(ThemeContext)

    return <StyledGlobalStyle $isDarkMode={theme === 'dark'}/>
}
